'use strict';

const angular = require('angular');
import { KUBERNETES_INSTANCE_CONTAINER_DETAIL } from './containerDetail.component';
module.exports = angular.module('spinnaker.instance.details.kubernetes', [
  require('./details.controller.js').name,
  KUBERNETES_INSTANCE_CONTAINER_DETAIL,
]);



// WEBPACK FOOTER //
// ./app/scripts/modules/kubernetes/src/instance/details/details.kubernetes.module.js